import { TableColumn, TableConfig, SORT_ORDER } from "../../../../@shared/models/table.models";

export const PEOPLE_TABLE_COLUMNS = (isAdmin: boolean, hasBillingAccess: boolean = false): TableColumn[] => {
    return [
        {
            field: "serialNumber",
            header: "S. No.",
            type: "text",
            width: "10%",
            sortable: true
        },
        {
            field: "fullName",
            header: "Name",
            type: "custom",
            template: "nameTemplate",
            width: "25%",
            sortable: true
        },
        {
            field: "contact",
            header: "Contact",
            type: "custom",
            template: "contactTemplate",
            width: "20%"
        },
        {
            field: "email",
            header: "Email",
            type: "custom",
            template: "emailTemplate",
            width: "25%",
            sortable: true
        },
        {
            field: "role",
            header: "Position",
            type: "custom",
            template: "roleTemplate",
            width: "15%",
            sortable: true
        },
        {
            field: "additionalRoles",
            header: "Additional Roles",
            type: "custom",
            template: "additionalRolesTemplateRef",
            width: "15%",
            sortable: true
        },
        ...(isAdmin ? [
            {
                field: "changePlan",
                header: "Plan",
                type: "custom" as TableColumn['type'],
                template: "changePlanTemplate",
                width: "15%"
            },
            // {
            //     field: "askMode",
            //     header: "Ask Mode",
            //     type: "custom" as TableColumn['type'],
            //     template: "askModeTemplate",
            //     width: "20%"
            // },
            // {
            //     field: "agentMode",
            //     header: "Agent Mode",
            //     type: "custom" as TableColumn['type'],
            //     template: "agentModeTemplate",
            //     width: "20%"
            // },
            {
                field: "actions",
                header: "Actions",
                type: "custom" as TableColumn['type'],
                template: "actionsTemplate",
                width: "10%"
            }
        ] : [])
    ]
};

export const INVITES_TABLE_COLUMNS = (isAdmin: boolean): TableColumn[] => {
    return [
        {
            field: "serialNumber",
            header: "S. No.",
            type: "text",
            width: "15%",
            sortable: true
        },
        {
            field: "email",
            header: "Email",
            type: "custom",
            template: "emailTemplate",
            width: "40%",
            sortable: true
        },
        {
            field: "role",
            header: "Position",
            type: "custom",
            template: "roleTemplate",
            width: "25%",
            sortable: true
        },
        ...(isAdmin ? [{
            field: "actions",
            header: "Actions",
            type: "custom" as TableColumn['type'],
            template: "actionsTemplate",
            width: "20%"
        }] : [])
    ]
};

export const REQUESTS_TABLE_COLUMNS = (isAdmin: boolean, isHistory: boolean = false): TableColumn[] => {
    const base: TableColumn[] = [
        { field: "serialNumber", header: "S. No.", type: "text", width: "10%", sortable: true },
        { field: "email", header: "Email", type: "custom", template: "emailTemplate", width: "15%", sortable: true },
        { field: "name", header: "Name", type: "custom", template: "nameTemplate", width: "15%", sortable: true },
        { field: "role", header: "Role", type: "custom", template: "roleTemplate", width: "10%", sortable: true },
        { field: "workspace", header: "Workspace", type: "custom", template: "workspaceTemplate", width: "10%", sortable: true },
        { field: "requestedBy", header: "Requested By", type: "custom", template: "userTemplate", width: "12%" },
        { field: "requestStatus", header: "Status", type: "custom", template: "statusTemplate", width: "15%" },
    ];

    if (isHistory) {
        return [...base, { field: "actionTaken", header: "Action Taken", type: "custom", template: "historyActionTemplate", width: "15%" }];
    }

    return isAdmin
        ? [...base, { field: "actions", header: "Actions", type: "custom", template: "actionsTemplate", width: "20%" }]
        : base;
};

export const PEOPLE_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [10, 20, 50],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No people found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { } // Will be implemented in the component
};

export const INVITES_TABLE_CONFIG: TableConfig = {
    tableClass: "",
    selectable: false,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 20],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No invites found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { } // Will be implemented in the component
};

export const REQUESTS_TABLE_CONFIG = (isHistory: boolean = false, hasBillingAccess: boolean = false): TableConfig => ({
    tableClass: isHistory ? "history-requests-table" : "requests-table",
    selectable: !isHistory && hasBillingAccess,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 20],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: isHistory ? "No history found" : "No requests found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { }
});
